module.exports = __webpack_public_path__ + "img/Folded_Paper_case_thumbnail_Mobilyze.df19602a.jpg";